import { useErrorEvent } from './useErrorEvent';
import { useOpenEvent } from './useOpenEvent';
import { useSaveEvent } from './useSaveEvent';

export function useSubscriptionLogic() {
  const openLogic = useOpenEvent();
  const saveLogic = useSaveEvent();
  const errorLogic = useErrorEvent();

  return { ...openLogic, ...saveLogic, ...errorLogic } as const;
}
